import { contactFlows } from './contacto'
import { soporte } from './soporte'

export const flows = { ...contactFlows, soporte }
export { contactFlows, soporte }
